(function () {
  const fix = (el) => {
    if (el.style.zIndex !== '999') {
      el.style.setProperty('z-index', '999', 'important');
    }
  };
  const attach = (el) => {
    fix(el);
    new MutationObserver(() => fix(el)).observe(el, {
      attributes: true,
      attributeFilter: ['style']
    });
  };
  const find = () => {
    const el = document.getElementById('attentive_overlay');
    if (el) { attach(el); return true; }
    return false;
  };
  if (!find()) {
    const wait = new MutationObserver(() => { if (find()) wait.disconnect(); });
    wait.observe(document.body, { childList: true, subtree: true });
  }
})();
